import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Benxekhach from "components/Benxe/Benxekhach.js";
export default function BCBenxekhachthang() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Báo cáo tháng bến xe khách",
            tabContent: <Benxekhach />,
          },
        ]}
      />
    </div>
  );
}
